export default class Constants{

    // static sortingFields = [{"key": "10th", label : "10th Marks" , selected : false},
    // {"key": "12th", label : "12th Marks" , selected : false},
    // {"key": "cgpa", label : "College CGPA", selected : false},
    // {"key": "maxBacklogs", label : "Max Backlogs", selected : false},
    // {"key": "score", label : "Hackathon Score", selected : false}
    // ]

    constructor(){
        this.sortingFields = [
          {"key": "title", label : "Job title" , selected : false ,sortKey : "title"},
        {"key": "experience", label : "experience" , selected : false, sortKey : "experience"},
        {"key": "vacancies", label : "vacancies" , selected : false ,sortKey : "vacancies"},
        {"key": "none", label : "none" , selected : false ,sortKey : "none"},
        {"key": "noticePeriod", label : "notice period", selected : false ,sortKey : "noticePeriod"},
        
        //{"key": "designation", label: "designation" , selected: false, sortKey: "designation"}
        
        ]

        this.filterFields = [
            {title : "Experience", value : "experience"},
            {title : "No of Openings", value : "vacancies"},
            {title : "Notice Period", value : "noticePeriod"},
            {title : "Organizational Department", value : "orgtype"},
            {title : "Priority", value : "priority"},
            {title : "location", value : "location"},
            {title : "Hackathon score", value : "score"},
            {title : "Maxbacklogs", value : "backlogs"},
            {title : "CGPA" , value : "cgpa"},
            {title : "Designation" , value : "designation"}
          ]

        this.filterStatus = {
           "experience":false,
           "noticePeriod":false,
            "xii" : false,
            "cgpa" : false,
            "backlogs" : false,
            "eligibility" : false,
            "mainStatus" : false,
            "location" : false,
            "priority" : false,
            "orgtype" :false,
            "institute" : false,
            "score" : false,
            "designation" : false
          }

          this.sortStatus = {
            "x" : {selected : false, order : true},
            "xii" : {selected : false, order : true},
            "cgpa" : {selected : false, order : true},
            "backlogs" : {selected : false, order : true},
            "score" : {selected : false, order : true}
          }
    }


}